export const OPEN_LINKS_NEW_TAB_EXPERIMENT_CLICK =
  'pandc.vnext.editor.open_links_new_tab_experiment.click';
